import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Phone(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 16.974v-.025a1.005 1.005 0 00-.87-1.022 1.003 1.003 0 01-.1-.02c-1.77-.436-1.772-.437-2.83-.703a.995.995 0 01-.107-.034 1.015 1.015 0 00-1.067.226l-1.274 1.272a1 1 0 01-1.2.162 17.072 17.072 0 01-6.41-6.396 1 1 0 01.163-1.203L8.58 7.959a1.006 1.006 0 00.225-1.06 1.001 1.001 0 01-.035-.115l-.242-.993c-.223-.917-.264-1.084-.457-1.807a.998.998 0 01-.024-.117A1.006 1.006 0 007.036 3H4.01a1.014 1.014 0 00-.957.686c-.044.13-.061.268-.05.405a18.836 18.836 0 002.931 8.254l.005.007a18.59 18.59 0 005.726 5.714l.007.005a18.927 18.927 0 008.233 2.926 1.014 1.014 0 001.01-.601c.056-.129.085-.267.084-.407v-3.015zm-1.193 5.018a19.927 19.927 0 01-8.678-3.081 19.59 19.59 0 01-6.034-6.022 19.836 19.836 0 01-3.087-8.701 2.003 2.003 0 011.19-2.017c.256-.112.532-.17.811-.17h3.017a2.014 2.014 0 012.011 1.725c.196.734.24.912.464 1.833.063.26.14.58.24.987a2.003 2.003 0 01-.452 2.118L8.012 9.939a16.074 16.074 0 006.033 6.021l1.277-1.274a2.012 2.012 0 012.122-.452l.89.224 1.936.479A2.013 2.013 0 0122 16.974v3.01a2.006 2.006 0 01-2.193 2.008z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Phone);
export default ForwardRef;